export default __webpack_public_path__ + "static/media/orders_art.eb483154.svg";